module.exports = __webpack_public_path__ + "static/bg-mobile-313699c0724c972743fb045171765246.png";